import React from 'react';
import ReactDOM from 'react-dom/client';
import { FunnelErrorBoundary, installClientErrorTelemetry } from '@smallbiz/ui-primitives';
import App from './App';
import './styles/globals.css';

// Theme initialization is handled by the inline script in index.html.
// That script runs synchronously before this module loads, so by the time
// React mounts the correct theme class/attribute is already on <html>.

// #13671: install the client error funnel once, before render, and catch a render error at the
// root with a recover screen (as brand-sbi-worker and support-sbi do).
installClientErrorTelemetry();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <FunnelErrorBoundary component="portfolio-app" variant="app">
      <App />
    </FunnelErrorBoundary>
  </React.StrictMode>
);
